import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useContext, useState } from "react";
import { Drawer } from "antd";
import { useAuth } from "../../../../store/AuthContext/AuthContext";
import { DrawerContext } from "../../../../store/DrawerContext/DrawerContext";
import { useFetch } from "../../../../hooks/useFetch/useFetch";


export const LocationContentStatsDrawer = () => {

    const { projectGroup } = useAuth();
    
    const [reviewsKPIs, setReviewsKPIs] = useState<any>(null);
    const [reviewsData, setReviewsData] = useState<any>();
    const [locationInfo, setLocationInfo] = useState<any>();
    const [isLoading, setIsLoading] = useState(true);
    
    const { locationContentStatsDrawer, setLocationContentStatsDrawer} = useContext(DrawerContext)

    const { t } = useTranslation();    
    
    useFetch(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/' + locationContentStatsDrawer.location.groupAccount + '/summary/content?' + locationContentStatsDrawer.name, {}, [],    
        (data: any) => {
            setReviewsKPIs(data.reviewsKPIs);
            setReviewsData(data);
            setIsLoading(false);
            setLocationInfo(data.location);
        });

    return (

        <Drawer
            title={locationInfo && 
                <>
                    <div>{locationInfo.name}</div>
                    <small style={{color:'grey'}}>{locationInfo.address}</small>
                </>
            }
            placement="right"
            width={'75%'}
            open={true}
            onClose={() => setLocationContentStatsDrawer(null)}
            bodyStyle={{ background: '#F4F7FA' }}>              		                                
                
        </Drawer>
    )
}